<template>
<div>
    <div>
        <img src="../../../assets/images/book/book-title-logo.png" alt="" class="book-title-logo">
        <div class="book-titles">
            <span class="book-title">{{BookParentTitle}}</span> <span class="book-title-2">{{BookSubTitle}}</span>
            <span class="book-sub-title">Conversation Questions</span>
        </div>
        <div style="clear: both;"></div>
    </div>
    <div class="book-contents">
        <div class="book-bg">
            <img src="../../../assets/images/book/book-bg-logo.png" class="lengedu-logo">
        </div>
        <div class="book-content">
            <div v-if="questions!=null && questions.length>0" class="p-3">
              <div class="fs-5" v-for="(w,i) in questions.filter(x=>x!=null)" :key="w"><b>{{i+1}}.</b> {{w}}</div>
            </div>
            <div v-else class="text-center">
                Konuya ait soru bulunamdı.
            </div>
        </div>
    </div>
</div> 
</template>
<script>
import '../../../assets/styles/book-design.css';
  export default {
    name: "TabQuestion",
    props: {
      questions:{
        type:Array
      },
      bookTitle:{
        type: Object
      }
    },
    data() {
      return {
      }
    },
    computed: {
      BookParentTitle(){
        if(this.bookTitle){
            return this.bookTitle.bookParentTitle;
        }
        return '';
       },
       BookSubTitle(){
        if(this.bookTitle){
            return this.bookTitle.bookSubTitle;
        }
        return '';
       }
    },
    methods: {
       
    },
    mounted: function() {
        
    }
  };
  </script>
    
  <style></style>